import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Store } from "@ngxs/store";

import { PointOfInterest } from "../models";
import { IRequestsNestedState } from "../../ngxs/interfaces/requests.interface";
import {
  DeletePoiAction,
  LoadPoiAction,
  SavePoiAction,
} from "../../ngxs/poi/poi.actions";
import { PoiGetterState } from "../../ngxs/poi";

@Injectable({
  providedIn: "root",
})
export class PoiService {
  poiList$: Observable<PointOfInterest[]> = this.store.select(
    PoiGetterState.getPoi
  );
  loadPoiPostRequestState$: Observable<IRequestsNestedState> =
    this.store.select(PoiGetterState.getloadPoiPostRequestState);
  savePoiPostRequestState$: Observable<IRequestsNestedState> =
    this.store.select(PoiGetterState.getSavePoiPostRequestState);
  deletePoiPostRequestState$: Observable<IRequestsNestedState> =
    this.store.select(PoiGetterState.getDeletePoiPostRequestState);
  poiMarkers$: Observable<
    {
      options: google.maps.marker.AdvancedMarkerElementOptions;
      poi: PointOfInterest;
    }[]
  >;

  constructor(private store: Store) {
    this.poiMarkers$ = this.poiList$.pipe(
      map((res) => {
        return res.map((poi) => ({
          poi,
          options: {
            draggable: true,
            position: poi.latLngLiteral,
          },
        }));
      })
    );
  }

  loadPointsOfInterest() {
    this.store.dispatch(new LoadPoiAction());
  }

  savePointsOfInterest(poi: PointOfInterest) {
    this.store.dispatch(new SavePoiAction(poi));
  }

  deletePointsOfInterest(poiId: number) {
    this.store.dispatch(new DeletePoiAction(poiId));
  }
}
